/**
 * +-------------------------------------------------+
 * |                                                 |
 * | Function Global Untuk Pagination dan get Data   |
 * +_________________________________________________+
 * 
 * Asalkan function mixin dan vue componentnya sama pagination bisa berjalan
 */

export const PaginationPengajuanSertifikat = {
    data() {
      return {
        items: [],
        indexed: '',
        formFilter : {
            periode : '',
            idSertifikasi: '',
        },
        search : "",
        idRekomendasi : "",
        pageSize : "10",
        currentPage :0,
        timeout: 0,
        pagination: {
            totalPages: 0
        },
        no: 1,
      };
    },
    watch: {
        search: function (val) {            
            if(val != "") {
                clearTimeout(this.timeout);
                var vm = this
                this.timeout = setTimeout(function () {
                    // enter this block of code after 1 second
                    // handle stuff, call search API etc.
                    var searchVar = vm.search.trimStart();
                    var searchFinal = searchVar.trimEnd();
    
                    vm.getData("0", vm.pageSize, searchFinal, vm.formFilter.periode, vm.formFilter.idSertifikasi);
                }, 1000);
            } else {
                this.getData("0", this.pageSize, 'default', this.formFilter.periode, this.formFilter.idSertifikasi);
            }
        },
        searchRpl: function (val) {            
            if(val != "") {
                clearTimeout(this.timeout);
                var vm = this
                this.timeout = setTimeout(function () {
                    // enter this block of code after 1 second
                    // handle stuff, call search API etc.
                    var searchVar = vm.searchRpl.trimStart();
                    var searchFinal = searchVar.trimEnd();
    
                    vm.getData("0", vm.pageSize, searchFinal, vm.formFilter.periode, vm.formFilter.idSertifikasiRpl);
                }, 1000);
            } else {
                this.getData("0", this.pageSize, 'default', this.formFilter.periode, this.formFilter.idSertifikasiRpl);
            }
        },
     
        /**
         * 
         * End Data Peserta Sertifikasi RPl 
         */
        currentPage: function(val) {
            //alert val -1 
            var page = val - 1;
            this.indexed = page * 10;
            if(this.idTc != null || this.idTc != undefined) {
                this.getData(this.idTc,val - 1, this.pageSize, this.search, this.formFilter.periode, this.formFilter.idSertifikasi);                
            } else {
                this.getData(val - 1, this.pageSize, this.search, this.formFilter.periode, this.formFilter.idSertifikasi);
            }
        }
    },
    methods: {
        /**
         * 
         * Data Peserta Sertifikasi  
         */
       
        ltrim(str) {
            if(!str) return str;
            return str.replace(/^\s+/g, '');
        },
        changePageSize(e) {            
            var pageSize = "";
            var vm = this;
            if (e.target.value == "Semua Data") {
                pageSize = "50000";
                this.pageSize = pageSize;
            } else {
                pageSize = e.target.value;
                this.pageSize = pageSize;
            }

            this.getData("0", vm.pageSize, vm.search, vm.formFilter.periode, vm.formFilter.idSertifikasi);
        },
    }
  };